import axios from 'axios'

const config = {
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY,
  },
}

const TrackingCall = {
  async postTrack(trackEventType, elementId, elementType) {
    try {
      const URL = `${window.viewer.apiTracking}`
      const userId = sessionStorage.getItem('userId')
      const userBookId = sessionStorage.getItem('userBookId')
      const data = {
        params: {
          elementId,
          elementType,
          userBookId,
        },
        timestamp: new Date().toISOString(),
        trackEventType,
        userId,
      }

      const response = await axios.post(URL, data, config)
      return response
    } catch (error) {
      return error
    }
  },
}

export default TrackingCall
